import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';
import {map} from 'rxjs/operators';

@Injectable()
export class MbillServiceService {
  mbillService: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mbill_service/list/?';
  private ListClassRateByService = webapi + 'mbill_service_class_rate/list/?';
  private ListServicesBySgId = webapi + 'mbill_service/listsgid/';
  private AddRecord = webapi + 'mbill_service/create';
  private EditRecord = webapi + 'mbill_service/update';
  private GetRecord = webapi + 'mbill_service/byid/';
  private DeleteRecord = webapi + 'mbill_service/delete/';
  private AutoCompleteAll = webapi + 'mbill_service/serviceautocomplete?';
  private AutoPackageCompleteAll = webapi + 'mbill_service/servicepackageautocomplete?';
  private listForAuto = webapi + 'mbill_service/listforauto/?';
  private listautoservice = webapi + 'mbill_service/listautoservice/?';
  private listForAutoBySubGroup = webapi + 'mbill_service/listforautobysubgroup/?';
  private listForAutoByGroup = webapi + 'mbill_service/listforautobygroup/?';
  private ListServiceByGroupId = webapi + 'mbill_service/listgroupId/';
  private AddClassRates = webapi + 'mbill_service_class_rate/create';
  private EditClassRates = webapi + 'mbill_service_class_rate/update';
  private serviceListByGroupName = webapi + 'mbill_service/laboratoryservices/?';
  private radioServiceListByGroupName = webapi + 'mbill_service/radiologyservices/?';
  private ListServicesBySgIdListUrl = webapi + 'mbill_service/listsgidlist/';
  private GetDropDown = webapi + 'mbill_service/dropdown?';
  private listOtservice = webapi + 'mbill_service/otservicelist?';
  //emr
  private GetAllRecordOfSelectedDataBySubGroup = webapi + 'mbill_service/GetAllRecordOfSelectedDataBySubGroup/';
  private ReActiveRecord = webapi + 'mbill_service/reActive/';
  private DeListRecord = webapi + 'mbill_service/deactivated_list/?';


    constructor(private http: Http) {
  }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordForAuto(serviceName: any, serviceCode: any): Promise<any> {
    return this.http.get(this.listForAuto + 'serviceName=' + serviceName + '&serviceCode=' + serviceCode)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getRecordForAutos(serviceName: any, serviceCode: any): Promise<any> {
        return this.http.get(this.listautoservice + 'serviceName=' + serviceName + '&serviceCode=' + serviceCode)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getServiceListByGroupName(serviceName: any) {
    return this.http.get(this.serviceListByGroupName + 'servicename=' + serviceName)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRadioServiceListByGroupName(serviceName: any) {
    return this.http.get(this.radioServiceListByGroupName + 'servicename=' + serviceName)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordForAutoBySubGroup(serviceName: any, serviceCode: any, sgId: any): Promise<any> {
    // console.log(serviceName + ' ' + serviceCode + ' ' + sgId);
    return this.http.get(this.listForAutoBySubGroup + 'serviceName=' + serviceName + '&serviceCode=' + serviceCode + '&sgId=' + sgId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordForAutoByGroup(serviceName: any, serviceCode: any, groupId: any): Promise<any> {
    return this.http.get(this.listForAutoByGroup + 'serviceName=' + serviceName + '&serviceCode=' + serviceCode + '&groupId=' + groupId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordForAutoAll(searchString: any, sgId: any, groupId: any, isBestPackage: Boolean): Promise<any> {
    // console.log("search String:" + searchString + "   sgId:" + sgId + "    groupId:" + groupId);
    return this.http.get(this.AutoCompleteAll + 'searchString=' + searchString + '&sgId=' + sgId + '&groupId=' + groupId + '&serviceIsBestPackage=' + isBestPackage)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordPackageForAutoAll(searchString: any, sgId: any, groupId: any): Promise<any> {
    // console.log("search String:" + searchString + "   sgId:" + sgId + "    groupId:" + groupId);
    return this.http.get(this.AutoPackageCompleteAll + 'searchString=' + searchString + '&sgId=' + sgId + '&groupId=' + groupId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addClassRateRecordService(model: any) {
    return this.http.post(this.AddClassRates, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editClassRateRecordService(model: any) {
    return this.http.post(this.EditClassRates, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getServiceBySgId(sgId: any) {
    return this.http.get(this.ListServicesBySgId + sgId).pipe(
      map(
        (response: Response) => {
          const data = response.json();
          return data;
        }
      ));
      // .toPromise()
      // .then(response => response.json())
      // .catch(this.handleError);
  }

  getServiceBygroupId(groupId: any) {
    return this.http.get(this.ListServiceByGroupId + groupId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordsClassRateByService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListClassRateByService + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordsOtServiceByService(searchString: any) {
    return this.http.get(this.listOtservice + 'searchString=' + searchString)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getDropDown(currentPage: any, size: any, groupId: any, subGroupId: any, isBestPackage: Boolean, globalFilter: any): Promise<any> {
    return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&groupId=' + groupId + '&subGroupId=' + subGroupId + '&isBestPackage=' + isBestPackage + '&globalFilter=' + globalFilter)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  //EMR
  getAllRecordOfSelectedDataBySubGroup(subGroupId: any): Promise<any> {
    return this.http.get(this.GetAllRecordOfSelectedDataBySubGroup + subGroupId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getServiceBySgIdList(list: any) {
    return this.http.post(this.ListServicesBySgIdListUrl, JSON.stringify(list), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mbill-service/mbill-service.service.ts